export const PRIVACY_UPDATED = "24 agosto 2026";

export const PRIVACY_INTRO = [
  'La presente informativa descrive come Freedom Fitness Consulting LLC, che opera attraverso il marchio Helios / Fede & Fitness Italia e il servizio Tempio Vivo, raccoglie, utilizza, conserva e protegge i dati personali degli utenti.',
  'L\'informativa è resa ai sensi del Regolamento (UE) 2016/679 ("GDPR") e della normativa applicabile in materia di protezione dei dati personali.',
];

export const PRIVACY_SECTIONS = [
  {
    title: "1. Titolare del trattamento",
    blocks: [
      "Il Titolare del trattamento è:",
      "Freedom Fitness Consulting LLC\n30 N Gould St, STE R\nSheridan, WY 82801\nStati Uniti d'America",
      "Marchi e servizi utilizzati: Helios, Fede & Fitness Italia, Tempio Vivo.",
      "Contatto privacy: supporto@fedefitnessitalia.com",
    ],
  },
  {
    title: "2. Rappresentante nell'Unione Europea",
    blocks: [
      "Ai sensi dell'articolo 27 GDPR, Freedom Fitness Consulting LLC ha designato quale proprio rappresentante nell'Unione Europea:",
      "Chiara Perrone\nMalta, Unione Europea\nEmail: chiaraperrone35@gmail.com",
      "Il rappresentante può essere contattato dagli interessati e dalle autorità di controllo per questioni relative al trattamento dei dati personali e all'esercizio dei diritti previsti dal GDPR.",
      "La designazione del rappresentante UE non limita la responsabilità del Titolare del trattamento.",
    ],
  },
  {
    title: "3. A chi si applica questa informativa",
    blocks: ["Questa informativa si applica alle persone che:"],
    list: [
      "utilizzano l'app Tempio Vivo",
      "creano un account gratuito o a pagamento",
      "acquistano una membership o un servizio",
      "partecipano alla community",
      "utilizzano percorsi fitness, nutrizionali, educativi o spirituali",
      "utilizzano servizi di coaching",
      "partecipano a challenge, corsi, call o eventi",
      "inviano richieste di preghiera o testimonianze",
      "comunicano con coach, amministratori o altri membri attraverso Tempio Vivo",
    ],
  },
  {
    title: "4. Dati personali che possiamo raccogliere",
    blocks: [
      "A seconda delle funzionalità utilizzate, possiamo trattare le seguenti categorie di dati.",
      "4.1 Dati identificativi e account — Possiamo raccogliere:",
    ],
    list: [
      "nome e cognome",
      "nome visualizzato",
      "indirizzo email",
      "foto profilo",
      "città, regione o area geografica indicata dall'utente",
      "credenziali e informazioni necessarie all'autenticazione",
      "identificativi dell'account",
    ],
    blocksAfter: [
      "Le credenziali sono gestite mediante sistemi di autenticazione sicura.",
      "4.2 Dati relativi all'utilizzo di Tempio Vivo — Possiamo trattare informazioni relative a:",
    ],
    listAfter: [
      "percorsi iniziati o completati",
      "routine",
      "allenamenti",
      "attività registrate",
      "challenge",
      "badge",
      "progressi",
      "partecipazione a corsi",
      "partecipazione a call",
      "partecipazione a eventi",
      "interazioni con le funzionalità dell'app",
      "preferenze e impostazioni",
    ],
  },
  {
    title: "5. Dati relativi alla salute e al benessere",
    blocks: [
      "Alcune funzionalità possono comportare il trattamento di informazioni che, a seconda del loro contenuto e contesto, costituiscono dati relativi alla salute ai sensi dell'articolo 9 GDPR.",
      "Possono comprendere, se volontariamente comunicati o autorizzati dall'utente:",
    ],
    list: [
      "peso",
      "altezza",
      "attività fisica",
      "passi",
      "allenamenti",
      "limitazioni fisiche",
      "infortuni",
      "informazioni relative allo stato di salute",
      "condizioni rilevanti per l'attività fisica",
      "informazioni relative al benessere",
      "dati inseriti nei questionari destinati ai servizi personalizzati",
    ],
    blocksAfter: [
      "Quando richiesto dal GDPR, tali dati vengono trattati sulla base del consenso esplicito dell'interessato, ai sensi dell'articolo 9, paragrafo 2, lettera a), GDPR.",
      "Il consenso può essere revocato in qualsiasi momento. La revoca non pregiudica la liceità del trattamento effettuato prima della revoca.",
      "L'utente può inoltre revocare le autorizzazioni relative ai sensori, Apple Health, Health Connect o servizi analoghi direttamente dalle impostazioni del proprio dispositivo.",
      "Tempio Vivo non utilizza dati relativi alla salute per attività pubblicitarie basate sulla salute dell'utente.",
    ],
  },
  {
    title: "6. Dati relativi alla fede e alle convinzioni religiose",
    blocks: [
      "Tempio Vivo è una piattaforma con contenuti e community di ispirazione cristiana.",
      "L'utilizzo di alcune funzionalità può pertanto rivelare direttamente o indirettamente informazioni relative alle convinzioni religiose o filosofiche dell'utente, che costituiscono categorie particolari di dati personali ai sensi dell'articolo 9 GDPR.",
      "Tali informazioni possono emergere, ad esempio, attraverso:",
    ],
    list: [
      "richieste di preghiera",
      "testimonianze",
      "messaggi spirituali",
      "commenti",
      "post",
      "partecipazione a determinati percorsi",
      "risposte a questionari spirituali",
      "contenuti condivisi nella community",
      "conversazioni con coach, founder o altri utenti",
    ],
    blocksAfter: [
      "Quando richiesto dalla normativa applicabile, questi dati vengono trattati sulla base del consenso esplicito dell'interessato, ai sensi dell'articolo 9, paragrafo 2, lettera a), GDPR.",
      "L'utente non è obbligato a condividere informazioni personali relative alla propria fede per utilizzare le funzionalità del servizio che non richiedono tali informazioni.",
      "L'utente può revocare il proprio consenso in qualsiasi momento.",
    ],
  },
  {
    title: "7. Contenuti pubblicati nella community",
    blocks: ["Quando utilizzi funzionalità sociali o comunitarie possiamo trattare:"],
    list: [
      "post",
      "commenti",
      "messaggi",
      "testimonianze",
      "richieste di preghiera",
      "reazioni",
      "immagini",
      "eventuali altri contenuti caricati volontariamente",
    ],
    blocksAfter: [
      "L'utente deve tenere presente che i contenuti pubblicati in aree della community possono essere visibili agli altri membri autorizzati ad accedere a quella specifica area.",
      "Invitiamo pertanto gli utenti a non pubblicare informazioni personali o sensibili che non desiderano condividere con altri membri.",
      "La pubblicazione di una testimonianza all'interno di Tempio Vivo non autorizza automaticamente Freedom Fitness Consulting LLC a utilizzarla per pubblicità, sponsorizzazioni, social media o altre finalità promozionali esterne.",
      "Per tali utilizzi potrà essere richiesta una separata autorizzazione.",
    ],
  },
  {
    title: "8. Dati tecnici e di sicurezza",
    blocks: [
      "Possiamo raccogliere informazioni tecniche necessarie al funzionamento e alla sicurezza del servizio, tra cui:",
    ],
    list: [
      "identificativi tecnici",
      "identificativo del dispositivo",
      "token per notifiche push",
      "informazioni sul sistema operativo",
      "log",
      "informazioni diagnostiche",
      "dati relativi a errori e malfunzionamenti",
      "eventi di sicurezza",
      "informazioni necessarie a prevenire abusi e accessi non autorizzati",
    ],
  },
  {
    title: "9. Dati relativi ai pagamenti",
    blocks: [
      "I pagamenti possono essere gestiti tramite fornitori specializzati quali Stripe o, ove applicabile, attraverso i sistemi di pagamento degli store digitali.",
      "Freedom Fitness Consulting LLC non conserva normalmente i dati completi della carta di pagamento.",
      "Possiamo ricevere informazioni quali:",
    ],
    list: [
      "stato del pagamento",
      "identificativo della transazione",
      "importo",
      "valuta",
      "piano acquistato",
      "stato dell'abbonamento",
      "eventuale mancato pagamento",
      "dati necessari alla fatturazione e agli adempimenti amministrativi e fiscali",
    ],
  },
  {
    title: "10. Finalità e basi giuridiche",
    blocks: [
      "Trattiamo i dati personali esclusivamente quando esiste una base giuridica valida.",
      "Esecuzione del contratto — Ai sensi dell'articolo 6, paragrafo 1, lettera b), GDPR, trattiamo i dati necessari per:",
    ],
    list: [
      "creare e gestire l'account",
      "fornire Tempio Vivo",
      "fornire membership e servizi acquistati",
      "mostrare progressi, corsi, allenamenti e challenge",
      "gestire community e funzionalità richieste dall'utente",
      "fornire assistenza",
      "gestire servizi di coaching richiesti",
    ],
    blocksAfter: [
      "Obblighi di legge — Ai sensi dell'articolo 6, paragrafo 1, lettera c), GDPR possiamo trattare dati necessari per:",
    ],
    listAfter: [
      "contabilità",
      "fiscalità",
      "obblighi normativi",
      "gestione di richieste delle autorità",
      "adempimenti previsti dalla legge",
    ],
    blocksFinal: [
      "Consenso — Ai sensi dell'articolo 6, paragrafo 1, lettera a), GDPR possiamo utilizzare il consenso per attività che lo richiedono, comprese determinate comunicazioni o funzionalità opzionali. Per categorie particolari di dati, comprese salute e convinzioni religiose, utilizziamo il consenso esplicito ai sensi dell'articolo 9 GDPR quando questa costituisce la base appropriata.",
      "Legittimo interesse — Ai sensi dell'articolo 6, paragrafo 1, lettera f), GDPR possiamo trattare dati quando necessario per proteggere la sicurezza della piattaforma, prevenire frodi e abusi, tutelare utenti e infrastrutture, moderare la community, far rispettare i Termini di Servizio, accertare, esercitare o difendere diritti. Tali trattamenti vengono effettuati valutando e bilanciando il nostro interesse con i diritti e le libertà degli utenti.",
    ],
  },
  {
    title: "11. Notifiche",
    blocks: ["Tempio Vivo può inviare notifiche relative a:"],
    list: [
      "attività del percorso",
      "appuntamenti",
      "community",
      "challenge",
      "messaggi",
      "eventi",
      "aggiornamenti del servizio",
    ],
    blocksAfter: [
      "Quando necessario, le notifiche vengono inviate sulla base del consenso dell'utente.",
      "Le notifiche push possono essere disabilitate in qualsiasi momento dalle impostazioni del dispositivo o, quando disponibile, dall'app.",
    ],
  },
  {
    title: "12. Comunicazioni promozionali",
    blocks: [
      "Qualora vengano inviate comunicazioni promozionali tramite email, notifiche o altri canali, queste verranno effettuate sulla base della base giuridica richiesta dalla normativa applicabile.",
      "Quando il trattamento è basato sul consenso, l'utente può revocarlo in qualsiasi momento. La revoca è gratuita.",
      "Misurazione delle campagne pubblicitarie — Per capire se le nostre campagne pubblicitarie funzionano, l'applicazione può inviare a Meta Platforms Ireland Ltd. un numero limitato di segnalazioni tecniche, associate all'identificatore pubblicitario del dispositivo. Questo avviene esclusivamente previo consenso esplicito dell'utente, richiesto all'interno dell'applicazione. In assenza di consenso non viene inviata alcuna segnalazione e l'identificatore pubblicitario non viene raccolto: l'applicazione funziona esattamente allo stesso modo.",
      "Le segnalazioni che possono essere inviate sono soltanto tre e non contengono contenuti, messaggi, dati sanitari, nome o indirizzo email:",
    ],
    list: [
      "la creazione di un account, con la sola indicazione del metodo utilizzato",
      "l'avvenuta apertura di una conversazione con i fondatori, senza alcun ulteriore dato",
      "l'utilizzo di una parte del programma, senza alcuna indicazione di quale attività sia stata svolta",
    ],
    blocksAfter: [
      "La terza segnalazione è volutamente generica: poiché le attività proposte dall'applicazione hanno carattere spirituale, indicarne il contenuto equivarrebbe a comunicare convinzioni religiose, che costituiscono categoria particolare di dati ai sensi dell'articolo 9 GDPR.",
      "Pur non contenendo dati identificativi diretti, tali segnalazioni sono associate a un identificatore del dispositivo e costituiscono pertanto dati personali pseudonimizzati, non anonimi.",
      "Meta Platforms Ireland Ltd. opera come autonomo titolare del trattamento per le proprie finalità.",
      "Il consenso può essere revocato in qualsiasi momento dalla sezione «Io», alla voce «Misurazione pubblicitaria». La revoca non pregiudica la liceità del trattamento effettuato prima della revoca stessa.",
    ],
  },
  {
    title: "13. Fornitori e destinatari dei dati",
    blocks: [
      "Per erogare il servizio possiamo avvalerci di soggetti terzi che forniscono servizi tecnologici o professionali. Tra questi possono rientrare:",
    ],
    list: [
      "Supabase — database, infrastruttura e autenticazione",
      "Stripe — gestione dei pagamenti",
      "Expo — servizi tecnici e notifiche push",
      "Google — recapito delle notifiche push sui dispositivi Android (Firebase Cloud Messaging)",
      "Shopify — gestione del negozio e degli ordini dei prodotti",
      "Meta Platforms Ireland — misurazione delle campagne pubblicitarie, solo previo consenso (art. 12)",
      "Vercel — infrastruttura e servizi web",
      "Resend — invio delle email di servizio (conferma dell'indirizzo, recupero della password)",
      "CARTO — fornitura delle mappe geografiche mostrate nella sezione Connect",
      "Cloudflare (unpkg) — distribuzione delle librerie tecniche necessarie a mostrare la mappa",
      "Google (YouTube) e Vimeo — riproduzione dei video presenti nei contenuti",
      "provider di hosting",
      "fornitori di assistenza tecnica",
      "consulenti professionali",
      "commercialisti e consulenti legali",
      "fornitori strettamente necessari all'erogazione del servizio",
    ],
    blocksAfter: [
      "Quando tali soggetti trattano dati per nostro conto vengono nominati responsabili del trattamento ai sensi dell'articolo 28 GDPR, ove applicabile.",
      "Alcuni fornitori possono operare come autonomi titolari del trattamento per specifiche attività.",
      "Non vendiamo i dati personali degli utenti.",
    ],
  },
  {
    title: "14. Trasferimenti internazionali",
    blocks: [
      "Freedom Fitness Consulting LLC ha sede negli Stati Uniti. Alcuni fornitori possono inoltre trattare dati al di fuori dello Spazio Economico Europeo.",
      "Quando un trasferimento internazionale è soggetto alle disposizioni del GDPR, utilizziamo uno dei meccanismi consentiti dalla normativa applicabile, quali:",
    ],
    list: [
      "decisioni di adeguatezza della Commissione europea",
      "EU-US Data Privacy Framework, ove applicabile al destinatario",
      "Clausole Contrattuali Standard approvate dalla Commissione europea",
      "altre garanzie previste dagli articoli 44 e seguenti GDPR",
    ],
    blocksAfter: [
      "È possibile richiedere ulteriori informazioni sulle garanzie applicabili scrivendo al contatto privacy indicato nella presente informativa.",
    ],
  },
  {
    title: "15. Conservazione dei dati",
    blocks: [
      "I dati vengono conservati solo per il periodo necessario alle finalità per le quali sono stati raccolti e nel rispetto degli obblighi legali applicabili. In particolare:",
    ],
    list: [
      "i dati dell'account vengono normalmente conservati per tutta la durata dell'account",
      "i dati relativi a servizi e percorsi vengono conservati per il tempo necessario all'erogazione del servizio",
      "i dati basati sul consenso vengono trattati fino alla revoca del consenso o fino al venir meno della finalità",
      "i dati relativi a pagamenti, fatturazione e adempimenti fiscali vengono conservati per il periodo previsto dalla normativa applicabile",
      "i log di sicurezza possono essere conservati per il periodo ragionevolmente necessario alla protezione del servizio",
      "le informazioni necessarie all'accertamento, esercizio o difesa di diritti possono essere conservate fino alla scadenza dei relativi termini di prescrizione",
    ],
    blocksAfter: [
      "Quando un account viene eliminato, i dati vengono cancellati o anonimizzati secondo le tempistiche tecnicamente necessarie, salvo quelli che devono essere conservati per legge o per la tutela di diritti.",
      "Copie residue possono permanere temporaneamente nei sistemi di backup fino al normale ciclo di sovrascrittura o cancellazione.",
    ],
  },
  {
    title: "16. Cancellazione dell'account",
    blocks: [
      "L'utente può richiedere o effettuare la cancellazione dell'account attraverso le funzionalità messe a disposizione da Tempio Vivo.",
      "La cancellazione dell'account può comportare la perdita definitiva dell'accesso a progressi, storico, contenuti personali, badge, dati del percorso e servizi collegati all'account.",
      "La cancellazione dell'account non comporta necessariamente l'immediata cancellazione dei documenti che il Titolare deve conservare per obbligo di legge.",
    ],
  },
  {
    title: "17. Diritti dell'interessato",
    blocks: ["Nei casi previsti dal GDPR, l'utente può esercitare i seguenti diritti:"],
    list: [
      "accesso ai dati personali",
      "rettifica",
      "cancellazione",
      "limitazione del trattamento",
      "opposizione",
      "portabilità dei dati",
      "revoca del consenso",
      "diritto di non essere sottoposto a decisioni esclusivamente automatizzate nei casi previsti dalla legge",
    ],
    blocksAfter: [
      "La revoca del consenso non pregiudica la liceità del trattamento effettuato prima della revoca.",
      "Le richieste possono essere inviate a: chiaraperrone35@gmail.com",
      "Potremo richiedere informazioni ragionevolmente necessarie a verificare l'identità del richiedente.",
    ],
  },
  {
    title: "18. Reclamo all'autorità di controllo",
    blocks: [
      "L'utente ha diritto di proporre reclamo a un'autorità di controllo competente in materia di protezione dei dati personali, in particolare nello Stato membro dell'Unione Europea in cui risiede abitualmente, lavora oppure nel luogo in cui ritiene si sia verificata una violazione.",
      "L'esercizio di questo diritto non impedisce all'utente di contattarci preventivamente per cercare di risolvere la questione.",
    ],
  },
  {
    title: "19. Minori",
    blocks: [
      "Tempio Vivo è destinato a persone che abbiano compiuto almeno 16 anni.",
      "Non raccogliamo consapevolmente dati personali attraverso account appartenenti a persone di età inferiore a 16 anni.",
      "Qualora venissimo a conoscenza dell'esistenza di un account appartenente a un minore che non soddisfa i requisiti di età, potremo adottare le misure necessarie per limitarne l'accesso e cancellare i dati nei limiti previsti dalla normativa applicabile.",
      "Eventuali programmi o iniziative specificamente destinati ai minori saranno disciplinati separatamente.",
    ],
  },
  {
    title: "20. Sicurezza",
    blocks: [
      "Adottiamo misure tecniche e organizzative ragionevoli e proporzionate al rischio per proteggere i dati personali contro accesso non autorizzato, perdita, distruzione, alterazione, divulgazione non autorizzata e trattamento illecito.",
      "Nessun sistema informatico può tuttavia garantire una sicurezza assoluta.",
    ],
  },
  {
    title: "21. Dati personali di terzi",
    blocks: [
      "L'utente non deve pubblicare o comunicare dati personali di altre persone senza averne diritto.",
      "In particolare, nelle richieste di preghiera, testimonianze, chat e post nella community, invitiamo a evitare la divulgazione di informazioni sanitarie, intime o comunque sensibili appartenenti a terzi senza una base legittima.",
    ],
  },
  {
    title: "22. Modifiche alla Privacy Policy",
    blocks: [
      "La presente informativa può essere aggiornata per adeguarla a modifiche del servizio, a nuove funzionalità, a cambiamenti normativi, a modifiche dei fornitori e a nuove modalità di trattamento.",
      "La versione aggiornata sarà resa disponibile all'interno dell'app o sul sito.",
      "In caso di modifiche sostanziali, potremo informare gli utenti attraverso l'app, email o altri strumenti appropriati.",
      "Qualora una modifica richieda un nuovo consenso, questo verrà richiesto prima di effettuare il relativo trattamento.",
    ],
  },
  {
    title: "23. Contatti",
    blocks: [
      "Per domande relative alla presente informativa o al trattamento dei dati personali:",
      "Freedom Fitness Consulting LLC\n30 N Gould St, STE R\nSheridan, WY 82801\nUSA",
      "Rappresentante nell'Unione Europea:\nChiara Perrone\nMalta, Unione Europea",
      "Email: supporto@fedefitnessitalia.com",
    ],
  },
];
